<template>
  <b-form-group
    :id="id + 'group'"
    :label-for="id"
    :label="label"
    :state="state"
    :invalid-feedback="invalidFeedback"
    :description="description"
    :label-cols-sm="labelCols"
    :label-align-sm="labelAlign"
    content-cols-sm="9"
    class="cp-textfield"

  >
    <div v-if="viewmode">
      {{ value }}
    </div>
    <b-form-radio-group
      v-if="!viewmode"
      v-model="radioValue"
      :options="options"
      @change="updateValue"
    />
  </b-form-group>
</template>

<script>
import commonValidate from '@/mixins/commonValidate.js'

export default {
  mixins: [commonValidate],
  props: {
    id: { type: String, required: true },
    fieldname: { type: String, required: true },
    label: { type: String, default: null, required: false },
    value: { required: true },
    options: { type: Array, required: true },
    placeholder: { type: String, default: '', required: false },
    description: { type: String, default: '', required: false },
    viewmode: { type: Boolean, default: false, required: false },
    validators: { type: Array, defaule: [], required: false },
    disperror: { type: Boolean, default: false, required: false },
    labelCols: { type: Number, default: 3, required: false },
    labelAlign: { type: String, default: 'left', required: false }
  },
  setup (props) {
    let radioValue = props.value
    return {
      radioValue
    }
  },
  watch: {
    value (val, old) {
      if (typeof this.options[0].value === 'number') {
        this.radioValue = parseInt(val)
      } else {
        this.radioValue = val
      }
      if (old !== val) this.updateValue(val)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/fields/RadioField.vue